/**
 * FNV-1a over UTF-16 code units, returned as a uint32.
 *
 * Cheap, well distributed, and — unlike anything seeded from `Math.random` —
 * stable across reloads and machines, which is what both cache keys and
 * deterministic generated art need.
 */
export const fnv1a = (value: string): number => {
    let hash = 2166136261;

    for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }

    return hash >>> 0;
};

/**
 * Mulberry32 PRNG. Seed it with `fnv1a` to turn a stable string (an id, a slug)
 * into a repeatable stream of numbers in [0, 1).
 *
 * Each call advances the stream, so the *order* of draws is part of the output:
 * inserting a new draw shifts every value after it. Derive anything that must
 * stay put across code changes from the hash directly rather than the stream.
 */
export const mulberry32 = (seed: number) => {
    let state = seed | 0;

    return () => {
        state = (state + 0x6d2b79f5) | 0;

        let t = Math.imul(state ^ (state >>> 15), 1 | state);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;

        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
};
